import { Stack, Typography } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import React, { type FC, useState } from "react";

import { formatMetaDateTime } from "~/feature/event/components/EventMetaInfo/utils";
import { MarketsDataGrid } from "~/feature/event/components/MarketsDataGrid";
import { MarketsFiltersBar } from "~/feature/event/components/MarketsFilters";
import { EventPageSections } from "~/feature/event/constants";
import type { IAggregatedEvent } from "~/types/event";

import * as Styled from "./MarketsTabs.styles";

interface IMarketsTabProps {
  event: IAggregatedEvent;
  ref?: React.RefObject<HTMLDivElement | null>;
}

export const MarketsTabs: FC<IMarketsTabProps> = ({ ref, event, ...props }) => {
  const [value, setValue] = useState(0);
  const isGroupedEvents = (event.eventCount ?? 0) > 1;
  const showDetailsTab = !isGroupedEvents;

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Styled.Root
      ref={ref}
      component="section"
      id={EventPageSections.MarketsTabs}
    >
      <Tabs value={value} onChange={handleChange}>
        <Styled.Tab component="h2" label="Markets" />
        {showDetailsTab && <Styled.Tab component="h2" label="Details" />}
      </Tabs>

      {value === 0 && (
        <>
          <MarketsFiltersBar
            showGroupingSwitch={isGroupedEvents}
            platforms={event.platforms}
          />
          <MarketsDataGrid event={event} {...props} />
        </>
      )}

      {value === 1 && showDetailsTab && (
        <Styled.DetailsPanel>
          <Stack
            direction="row"
            sx={{
              gap: 4,
              flexWrap: "wrap"
            }}>
            <Stack spacing={0.5}>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  color: "text.secondary",
                  textTransform: "uppercase"
                }}>
                Created at
              </Typography>
              <Typography variant="caption" sx={{
                fontWeight: 500
              }}>
                {formatMetaDateTime(event.createdAt)}
              </Typography>
            </Stack>
            <Stack spacing={0.5}>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  color: "text.secondary",
                  textTransform: "uppercase"
                }}>
                Updated at
              </Typography>
              <Typography variant="caption" sx={{
                fontWeight: 500
              }}>
                {formatMetaDateTime(event.updatedAt)}
              </Typography>
            </Stack>
          </Stack>
        </Styled.DetailsPanel>
      )}
    </Styled.Root>
  );
};
